import { render } from "./AddFirstWorkspaceModal.vue?vue&type=template&id=df827ac0&scoped=true&ts=true"
import script from "./AddFirstWorkspaceModal.vue?vue&type=script&lang=ts"
export * from "./AddFirstWorkspaceModal.vue?vue&type=script&lang=ts"

import "./AddFirstWorkspaceModal.vue?vue&type=style&index=0&id=df827ac0&lang=scss&scoped=true"
import "./AddFirstWorkspaceModal.vue?vue&type=style&index=1&id=df827ac0&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df827ac0"]])

export default __exports__